export default __webpack_public_path__ + "static/media/Modelhomepage_GIF_new.d3077f8a.png";